"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Object to keep all needed data, which should be sent to dynamic.service by communicatoin service.
 */
var /**
 * Object to keep all needed data, which should be sent to dynamic.service by communicatoin service.
 */
ParentFilterDto = /** @class */ (function () {
    function ParentFilterDto(parentFilter, parentCategoryName, fieldSystemNameInParentEntity) {
        this._parentFilterCriteria = parentFilter;
        this._parentCategoryName = parentCategoryName;
        this._fieldSystemNameInParentEntity = fieldSystemNameInParentEntity;
    }
    Object.defineProperty(ParentFilterDto.prototype, "parentFilterCriteria", {
        get: function () {
            return this._parentFilterCriteria;
        },
        set: function (value) {
            this._parentFilterCriteria = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParentFilterDto.prototype, "parentCategoryName", {
        get: function () {
            return this._parentCategoryName;
        },
        set: function (value) {
            this._parentCategoryName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParentFilterDto.prototype, "fieldSystemNameInParentEntity", {
        get: function () {
            return this._fieldSystemNameInParentEntity;
        },
        set: function (value) {
            this._fieldSystemNameInParentEntity = value;
        },
        enumerable: true,
        configurable: true
    });
    return ParentFilterDto;
}());
exports.ParentFilterDto = ParentFilterDto;
//# sourceMappingURL=parent-filter-dto.js.map